export const modalItemList = [
  {
    number: '01',
    id: '01',
    title: 'Unashamed',
    role: 'UI/Character designer',
    imageName: '01',
    // TODO: Update the date
    date: '2019.4',
    routeName: 'First'
  },
  {
    number: '02',
    id: '02',
    title: 'Art At Heart',
    role: 'UI/UX designer',
    imageName: '02',
    date: '2019.4',
    routeName: 'Second',
  },
  {
    number: '03',
    id: '03',
    title: 'Dreamlist',
    role: 'App&Web designer',
    imageName: '03',
    date: '2019.7',
    routeName: 'Third'
  },
  {
    number: '04',
    id: '04',
    title: 'Scanny',
    role: 'UI/UX designer',
    imageName: '04',
    date: '2019.5',
    routeName: 'Fourth'
  },
  /*
  {
    number: '05',
    id: '05',
    title: 'Flip',
    role: 'App designer',
    imageName: '05',
    date: '2019.3',
    routeName: 'Fifth'
  }
  */
]

export const pageData = {
  '01': {
    number: '01',
    title: 'Unashamed',
    introduction: '<strong>"Unashamed"</strong> is an organization that aims to provide teachers with successful and engaing lessons on contraception.',
    role: 'UI designer, Character designer',
    projectType: 'Interdisciplinary group project',
    members: 'Hwajung Jin, Taylor Sparks,Jodie Anne, Hyein Lee, Cheryl',
    imgs: {
      topMain: '01.png',
      pageIntro: '01.jpg'
    },
    routeName: 'First'
  },
  '02': {
    number: '02',
    title: 'Art At Heart',
    introduction: '<strong>Art at heart</strong> is an organization that inspires and motivated young, diverse, artistic people to volunteer at the Auckland Art Gallery.',
    role: 'UI/UX designer, Researcher',
    projectType: 'Commercial project',
    members: 'Hwajung Jin, Taylor Sparks,Jade Berge',
    imgs: {
      topMain: '02.png',
      pageIntro: '02.png'
    },
    routeName: 'Second'
  },
  '03': {
    number: '03',
    title: 'Dreamlist',
    introduction: '<strong>The dreamlist</strong> is a bucketlist social network app for dreaming youth.',
    role: 'UI/UX designer, Researcher',
    projectType: 'Start-up project',
    members: null,
    imgs: {
      topMain: '03.png',
      pageIntro: '03.png'
    },
    routeName: 'Third'
  },
  '04': {
    number: '04',
    title: 'Scanny',
    introduction: '<strong>Scanny</strong> is a skin dignosising All-in-one smart mirror.',
    role: 'UI/UX designer, Researcher',
    projectType: 'Speculative design project',
    members: null,
    imgs: {
      topMain: '04.png',
      pageIntro: '04.jpg'
    },
    routeName: 'Fourth'
  },
  '05': {
    number: '05',
    title: 'Flip',
    introduction: '<strong>The Flip</strong> is an app for help you to find every festivals around you.',
    role: 'UI/UX designer, Researcher',
    projectType: 'Start-up project',
    members: null,
    imgs: {
      topMain: '05.png',
      pageIntro: null
    },
    routeName: 'Fifth'
  }
}